import { apiClient } from './client';
import {
  ExternalAuditGuestIssueRequest,
  GuestAccess,
  GuestIssueRequest,
  GuestIssueResponse,
} from '../types/guestAccess';

export async function issueGuest(payload: GuestIssueRequest): Promise<GuestIssueResponse> {
  const { data } = await apiClient.post<GuestIssueResponse>('/companies/guests', payload);
  return data;
}

export async function listGuests(): Promise<GuestAccess[]> {
  const { data } = await apiClient.get<GuestAccess[]>('/companies/guests');
  return data;
}

export async function revokeGuest(guestAccessId: number): Promise<GuestAccess> {
  const { data } = await apiClient.post<GuestAccess>(`/companies/guests/${guestAccessId}/revoke`);
  return data;
}

export async function issueExternalAuditGuest(
  reportId: number,
  payload: ExternalAuditGuestIssueRequest
): Promise<GuestIssueResponse> {
  const { data } = await apiClient.post<GuestIssueResponse>(
    `/external-audits/${reportId}/guests`,
    payload
  );
  return data;
}
